// extracted by mini-css-extract-plugin
export default {"nav_container":"Header_nav_container__-ZUfy","desktop_menu":"Header_desktop_menu__gBB7R","nav_brand":"Header_nav_brand__g+ejU"};